import { render, staticRenderFns } from "./FormAdminProfile.vue?vue&type=template&id=4612fd70&scoped=true&"
import script from "./FormAdminProfile.vue?vue&type=script&lang=js&"
export * from "./FormAdminProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4612fd70",
  null
  
)

export default component.exports